import * as React from "react";
import { observer } from "mobx-react";

interface IVideoProps {
	params: IVideoParamsProps;
}

interface IVideoParamsProps {
	videoSrc: string;
	videoType: string;
}

@observer
export class VideoComponent extends React.Component<IVideoProps, {}> {

	preventContextMenu(event: React.MouseEvent<HTMLVideoElement>) {
		event.preventDefault();
		return false;
	}

	render() {
		return <div className="video">
			<video className="video__player" ref="videoComponent" autoPlay controls controlsList="nodownload" onContextMenu={this.preventContextMenu}>
				<source src={this.props.params.videoSrc} type={this.props.params.videoType} />
			</video>
		</div>;
	}
}

//import * as React from "react";
//import { observer } from "mobx-react";
//import { observable } from "mobx";
//import { Toolbar } from "../General/Toolbar";
//import { FullScreen } from "../General/FullScreen";
//import { FullScreenButton } from "../Buttons/FullScreenButton";
//import { MuteButton } from "../Buttons/Video/MuteButton";
//import { StartStopButton } from "../Buttons/Video/StartStopButton";
//import { SeekButton } from "../Buttons/Video/SeekButton";

//interface IVideoProps {
//	params: IVideoParamsProps;
//}

//interface IVideoParamsProps {
//	videoSrc: string;
//	videoType: string;
//}

//@observer
//export class VideoComponent extends React.Component<IVideoProps, {}> {

//	video: any;
//	@observable timeLapse: string = "00:00/00:00";
//	@observable seekbarValue: string = "0";
//	@observable volumeValue: string = "100";
//	@observable seekbarMax: string = "0";
//	@observable playingState: number = 0;
//	@observable muteState: number = 0;

//	prevVolume: number = 100;

//	componentDidMount() {
//		this.video = this.refs.videoComponent;
//		this.registerEvents();
//	}

//	play = () => {
//		(this.video.ended || this.video.paused) ? this.video.play() : this.video.pause();
//	}

//	volume = (event: MouseEvent) => {
//		let value = (event.target as any).value as number;
//		this.volumeValue = value.toString();
//		this.video.volume = value / 100;
//		if (value != 0) {
//			this.video.muted = false;
//			this.muteState = 0;
//		}
//		else {
//			this.muteState = 1;
//		}
//	}

//	mute = () => {
//		if (this.video.muted) {
//			this.muteState = 0;
//			this.volumeValue = this.prevVolume.toString();
//		}
//		else {
//			this.prevVolume = this.video.volume * 100;
//			this.muteState = 1;
//			this.volumeValue = "0";
//		}
//		this.video.muted = !this.video.muted;
//	}

//	registerEvents = () => {
//		this.video.addEventListener('loadedmetadata', () => {
//			this.seekbarMax = this.video.duration;
//			this.timeLapse = "00:00/" + this.formatTime(this.video.duration);
//		});
//		this.video.addEventListener('timeupdate', () => {
//			this.seekbarMax = this.video.duration;
//			this.seekbarValue = this.video.currentTime;
//			this.timeLapse = this.formatTime(this.video.currentTime) + "/" + this.formatTime(this.video.duration);
//		});
//		this.video.addEventListener('play', () => {
//			this.playingState = 1;
//		});
//		this.video.addEventListener('pause', () => {
//			this.playingState = 0;
//		});
//		this.video.addEventListener('ended', () => {
//			this.playingState = 0;
//		});
//	}

//	seekbar = (event: MouseEvent) => {
//		let value = (event.target as any).value as number;
//		this.seekbarValue = value.toString();
//		this.timeLapse = this.formatTime(value) + "/" + this.formatTime(this.video.duration);
//		this.video.currentTime = value;
//	}

//	formatTime = (duration: number) => {
//		let sec: number;
//		let min: number;
//		sec = Math.floor(duration);
//		min = Math.floor(sec / 60);
//		min = min >= 10 ? min : 0 + min;
//		sec = Math.floor(sec % 60);
//		sec = sec >= 10 ? sec : 0 + sec;
//		return min + ":" + sec;
//	}
//	render() {
//		return <div className="video">
//			<FullScreen>
//				<video className="video__player" ref="videoComponent" autoPlay>
//					<source src={this.props.params.videoSrc} type={this.props.params.videoType}></source>
//				</video>
//				<div >
//					<Toolbar>
//						<span className="buttongroup is--buttongroup-left">
//							<StartStopButton onClick={this.play} switchState={this.playingState} />
//							<label>{this.timeLapse}</label>
//							<SeekButton onChange={this.seekbar.bind(this)} max={this.seekbarMax} step="0.1" value={this.seekbarValue} />
//						</span>
//						<span className="buttongroup is--buttongroup-right">
//							<MuteButton onClick={this.mute} switchState={this.muteState} />
//							<SeekButton onChange={this.volume.bind(this)} max="100" step="1" defaultValue="100" value={this.volumeValue} />
//							<FullScreenButton />
//						</span>
//					</Toolbar>
//				</div>
//			</FullScreen>
//		</div>;
//	}
//}